"use client";

import LayoutNotAuthorized from "@portal/components/organisms/layouts/Layout-NotAuthorized";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import { TextResources } from "@portal/assets/text/TextResources";
import { useRouter } from "next/navigation";
import Icon from "@portal/components/atoms/icons";
import { Suspense } from "react";
import useCenterIdOpenPages from "@portal/hooks/useCenterIdOpenPages";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import Typography from "@portal/components/atoms/v2/typography";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Button from "@portal/components/atoms/v2/buttons/button";
import ThemeProvider from "@portal/components/organisms/layouts/themeProvider";

const NotFoundPage = () => {
  const centerId = useCenterIdOpenPages();
  const router = useRouter();
  return (
    <ThemeProvider>
      <LayoutNotAuthorized centerId={centerId}>
        <PortalPageBox>
          <div className="flex flex-col justify-center items-center space-y-3">
            <Icon name="questionMarkCircleIcon" size="xxxlarge" />
            <div>
              <Typography variant="H6">{TextResources.NOT_FOUND_PAGE_TITLE}</Typography>
              <TextLine />
            </div>
            <Typography variant="Body">{TextResources.NOT_FOUND_PAGE_TEXT}</Typography>
            <div className="mt-5">
              <Button
                text={TextResources.NOT_FOUND_PAGE_GO_HOME}
                wide
                onClick={async () => {
                  router.push("/");
                }}
              />
            </div>
          </div>
        </PortalPageBox>
      </LayoutNotAuthorized>
    </ThemeProvider>
  );
};

const NotFoundPageWrapper = () => (
  <Suspense fallback={<PageSpinner />}>
    <NotFoundPage />
  </Suspense>
);

export default NotFoundPageWrapper;
